import * as C from '../constants';
import xmlStatsService from '../../../services/xml-stats-service';
import coreService from '../../../services/core-service';

export default {
  /**
   * @param commit
   * @param payload
   */
  initiateSetup({ commit }) {
    commit(C.REQUEST_INITIATE_SETUP_PENDING);

    // GET REQUEST TYPES
    const getRequestTypes = new Promise((resolve, reject) => {
      commit(C.REQUEST_TYPES_LIST_PENDING);
      xmlStatsService.getRequestTypes({})
        .then((res) => {
          if (res.status === 200) {
            resolve();
            commit(C.REQUEST_TYPES_LIST_SUCCESS, res.data);
          } else {
            resolve();
            commit(C.REQUEST_TYPES_NO_CONTENT);
          }
        })
        .catch(() => {
          reject();
          commit(C.REQUEST_TYPES_LIST_FAILURE);
        });
    });

    // GET CHANNELS LIST
    const getChannels = new Promise((resolve, reject) => {
      commit(C.REQUESTS_CHANNEL_LIST_PENDING);
      xmlStatsService.getXmlChannels({})
        .then((res) => {
          if (res.status === 200) {
            resolve();
            commit(C.REQUESTS_CHANNEL_LIST_SUCCESS, res.data);
          } else {
            resolve();
            commit(C.REQUESTS_CHANNEL_LIST_NO_CONTENT);
          }
        })
        .catch(() => {
          reject();
          commit(C.REQUESTS_CHANNEL_LIST_FAILURE);
        });
    });

    // GET REQUEST TYPES
    const getDomains = new Promise((resolve, reject) => {
      commit(C.REQUESTS_DOMAINS_LIST_PENDING);
      coreService.getDomains({})
        .then((res) => {
          if (res.status === 200) {
            resolve();
            commit(C.REQUESTS_DOMAINS_LIST_SUCCESS, res.data);
          } else {
            resolve();
            commit(C.REQUESTS_DOMAINS_LIST_NO_CONTENT);
          }
        })
        .catch(() => {
          reject();
          commit(C.REQUESTS_DOMAINS_LIST_FAILURE);
        });
    });

    Promise.all([getRequestTypes, getChannels, getDomains]).then(() => {
      commit(C.REQUEST_INITIATE_SETUP_SUCCESS);
    }).catch(() => {
      commit(C.REQUEST_INITIATE_SETUP_FAILURE);
    });
  },
  /**
   * @param commit
   * @param searchParamaters
   * @param payload
   */
  getRequests({ commit }, searchParameters) {
    const pIds = [];
    const searchParams = searchParameters;
    Object.keys(searchParams)
      .forEach(key => (searchParams[key] === '' ? delete searchParams[key] : {}));

    commit(C.REQUESTS_LIST_PENDING);

    xmlStatsService.getRequests(searchParams)
      .then((res) => {
        if (res.status === 200) {
          res.data.forEach((request) => {
            if (request.xmlChannelProductId) {
              pIds.push(parseInt(request.xmlChannelProductId, 0));
            }
          });
          if (pIds.length) {
            xmlStatsService.getProducts(pIds)
              .then((resp) => {
                if (resp.status === 200) {
                  commit(C.REQUESTS_LIST_SUCCESS, { requests: res.data, products: resp.data });
                } else {
                  commit(C.REQUESTS_LIST_NO_CONTENT);
                }
              })
              .catch(() => {
                commit(C.REQUESTS_LIST_FAILURE);
              });
          } else {
            commit(C.REQUESTS_LIST_SUCCESS, { requests: res.data, products: [] });
          }
        } else {
          commit(C.REQUESTS_LIST_NO_CONTENT);
        }
      })
      .catch(() => {
        commit(C.REQUESTS_LIST_FAILURE);
      });
  },
  /**
   * @param commit
   * @param requestId
   * @param payload
   */
  getRequestLogFilesList({ commit }, requestId) {
    commit(C.REQUEST_LOG_FILES_LIST_PENDING);
    xmlStatsService.getRequestLogs(requestId)
      .then((res) => {
        if (res.status === 200) {
          commit(C.REQUEST_LOG_FILES_LIST_SUCCESS, res.data);
        } else {
          commit(C.REQUEST_LOG_FILES_LIST_NO_CONTENT);
        }
      })
      .catch(() => {
        commit(C.REQUEST_LOG_FILES_LIST_FAILURE);
      });
  },
  /**
   * @param commit
   * @param index
   * @param payload
   */
  setRequestsPaginationIndex({ commit }, index) {
    commit(C.REQUESTS_SET_PAGINATION_INDEX, index);
  },
  /**
   * @param commit
   */
  updateRequestsPaginationIndex({ commit }) {
    commit(C.REQUESTS_UPDATE_PAGINATION_INDEX);
  },
  /**
   * @param commit
   */
  resetRequestsPaginationIndex({ commit }) {
    commit(C.REQUESTS_RESET_PAGINATION_INDEX);
  },
  /**
   * @param commit
   * @param request
   * @param payload
   */
  openRequest({ commit }, request) {
    commit(C.REQUESTS_SET_REQUEST, request);
  },
  /**
   * @param commit
   */
  closeRequest({ commit }) {
    commit(C.REQUESTS_RESET_REQUEST);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/requestStatus/actions.js